import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {changeLanguage} from '../../i18n/action/i18nActions';
import '../style/LanguageSelector.less';

function LanguageSelector() {
    const dispatch = useDispatch();
    const currentLanguage = useSelector(state => state.i18n.currentLanguage);
    const languages = useSelector(state => state.i18n.languages);

    function handleChange(newLanguage) {
        dispatch(changeLanguage(newLanguage));
    }

    return (
        <ul className="language-selector mb-1">
            {
                languages.map(language =>
                    language.value !== currentLanguage &&
                    <li key={language.value}>
                        <a
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                handleChange(language.value);
                            }}>{language.label}</a>
                    </li>
                )
            }
        </ul>
    );
}

export default LanguageSelector;
